import React from "react"

import * as eduCardStyles from "../styles/EduCard.module.css"

import { ChildSelector } from "../helpers/ChildSelector"
import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import PostLinksParser from "../helpers/PostLinksParser"

export default function GenericSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `card-title`,
    ChildSelector.SELECTOR_TYPE.INNER_HTML
  )

  // console.log(PostLinksParser(title))

  const textStack = content.childNodes
    .filter(node => node.classNames === "card-content")
    .map(t => t.text)

    const introList = ChildSelector.select(
      content,
      `second-list-intro`,
      ChildSelector.SELECTOR_TYPE.TEXT
    )

  const featuresList = ChildSelector.select(
    content,
    `card-list`,
    ChildSelector.SELECTOR_TYPE.NODE
  )
  const secondFeaturesList = ChildSelector.select(
    content,
    `second-card-list`,
    ChildSelector.SELECTOR_TYPE.NODE
  )

  return (
    <>
      <div className={`row ${props.className} ${eduCardStyles.wrapper}`}>
        <div className={`col-1 ${eduCardStyles.icon}`}>
          <WPImage
            holder={content}
            selector={`card-icon`}
            mode={DISPLAY_MODE.inline}
          />
        </div>
        <div className={`col-11 col-sm-12 col-md-11 col-lg-11 ${eduCardStyles.content}`}>
          <h1
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
          <ul className={`${eduCardStyles.content}`}>
            {featuresList &&
              featuresList.childNodes &&
              featuresList.childNodes.length > 0 &&
              featuresList.childNodes.map((r, idx) => (
                <li
                  key={idx}
                  className={`${eduCardStyles.contentItem}`}
                  dangerouslySetInnerHTML={{ __html: r.innerHTML }}
                />
              ))}
          </ul>
          <p>{introList}</p>
          <ul className={`${eduCardStyles.content}`}>
            {secondFeaturesList &&
              secondFeaturesList.childNodes &&
              secondFeaturesList.childNodes.length > 0 &&
              secondFeaturesList.childNodes.map((r, idx) => (
                <li
                  key={idx}
                  className={`${eduCardStyles.contentItem}`}
                  dangerouslySetInnerHTML={{ __html: r.innerHTML }}
                />
              ))}
          </ul>
        </div>
      </div>
    </>
  )
}
